export default "__VITE_ASSET__BbfghCBY__"